import styled from 'styled-components'

export default styled.label`
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  text-align: left;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.black};
`
